const usePermissionConfig = () => {
  return {
    /*
    * 同步
    * 控制：同步
    * 跳转路由名称：
    * */
    SYNC: 'OPS-SPFW-CYCRZ-TB',
  };
};

export default usePermissionConfig;
